module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGUlEQVR4nGOwd/b8TwlmGDVg1IBRA4aLAQBnf8oQch5ynAAAAABJRU5ErkJggg=="